<template>
  <div class="staff-card-widget">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <span class="badge text-white mr-2 p-1 font-size-12" style="background-color: #722ed1;">
          <i class="fe fe-users"></i> Staff
        </span>
        <h6 class="mb-0 font-weight-bold text-dark">Staff & Faculty</h6>
      </div>
      <div class="text-right">
        <span class="font-size-24 font-weight-bold" style="color: #722ed1;">{{ totalStaff || 0 }}</span>
        <span class="text-muted font-size-12 ml-1">Members</span>
      </div>
    </div>

    <div class="mt-3 pt-2 border-top">
      <div class="d-flex align-items-center justify-content-between font-size-13 text-gray-7">
        <span><i class="fe fe-info text-primary mr-1"></i>Total Staff Count:</span>
        <strong class="text-dark font-size-14">{{ totalStaff || 0 }}</strong>
      </div>
      <div class="font-size-12 text-muted mt-1">
        Includes all teaching & non-teaching staff
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeoStaffCard',
  props: {
    totalStaff: {
      type: [Number, String],
      default: 0,
    },
  },
}
</script>

<style scoped>
.staff-card-widget {
  width: 100%;
}
</style>
